import { Component, OnInit } from '@angular/core';
import {SetupService} from "../../../Services/setup.service";
import {Setup} from "../../../Models/setup";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
    setup: Setup = new Setup();  constructor(private setupSer:SetupService) { }

  ngOnInit(): void {
      this.setupSer.getSetup().subscribe(x=>{
          this.setup = x;
      })
  }

}
